// Defining the layout configuration specific to Demo9 layout
const MainLayoutConfig = {
  name: 'main-layout',
  // Unique name identifier for this layout
  options: {
    header: {
      stickyOffset: 200 // Offset value (in pixels) that determines when the header becomes sticky on scroll
    }
  }
};
export { MainLayoutConfig };